import type { IDiscountDetailsResources } from "@/src/discount/DiscountDetails.Resources";

export const DiscountDetailsResourcesEn: IDiscountDetailsResources = {
    goToOfferButton: "Go to website",
};
